export const ID_REASON_IMPEDIMENT = '3';
